class ProductMoreInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const subheadings = this.querySelectorAll('[data-info]');
    this.querySelectorAll('[data-info]').forEach((infoSelector) => {
      infoSelector.addEventListener('click', () => {
        const infoName = infoSelector.dataset.info;
        const infoBlock = this.querySelector(`[data-info-block="${infoName}"]`);

        if (infoBlock) {
          this.querySelectorAll('[data-info-block]').forEach((info) => {
            info.classList.remove('!tw-block');
          });

          infoBlock.classList.add('!tw-block');
        }

        this.querySelectorAll('[data-info]').forEach((btn) => {
          btn.classList.remove('tw-font-semibold');
          btn.querySelector('[data-plus]').classList.remove('!tw-hidden');
          btn.querySelector('[data-minus]').classList.remove('!tw-block');
          btn.querySelector('[data-highlight]').classList.remove('!tw-block');
        });

        const sameInfoSubheadings = Array.from(subheadings).filter((sh) => sh.dataset.info === infoName);
        sameInfoSubheadings.forEach((infoSelector) => {
          infoSelector.classList.add('tw-font-semibold');
          infoSelector.querySelector('[data-plus]').classList.add('!tw-hidden');
          infoSelector.querySelector('[data-minus]').classList.add('!tw-block');
          infoSelector.querySelector('[data-highlight]').classList.add('!tw-block');
        });

        // Scroll the component just below the header
        // Only scroll on mobile (<1024px)
        if (window.innerWidth < 1024) {
          const header = document.querySelector('store-header');
          const headerHeight = header ? header.offsetHeight : 0;

          const subHeadingsEl = infoSelector.closest('.benefit-subheadings');
          if (!subHeadingsEl) return;

          const offset = subHeadingsEl.getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight + 2;

          window.scrollTo({ top: Math.max(offset, 0), behavior: 'smooth' });
        }
      });
    });
  }
}

customElements.define('product-more-info', ProductMoreInfo);